var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWill2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e2d1fa",
    d: "M1,6c0-2.2091,1.7909-4,4-4h1c2.2091,0,4,1.7909,4,4v2H1V6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9,2h20c2.2091,0,4,1.7909,4,4v27H13c-2.2091,0-4-1.7909-4-4V2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2d1fa",
    d: "M37,28c0,2.2091-1.7909,4-4,4H16v-6h21V28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#090927",
    d: "M37.0104,24.7h-3.3646V6.8c0-3.7-3.0677-6.8-6.7291-6.8H5.3438C2.375,0,0,2.4,0,5.4v2.9 c0,0.6,0.3958,1,0.9896,1h7.6198v20.8c0,2.2,1.7812,3.9,3.8594,3.9h20.1874C36.0208,34,38,31.3,38,28.6v-2.9 C38,25.2,37.5052,24.7,37.0104,24.7z M1.9792,5.4c0-1.9,1.4844-3.4,3.3646-3.4s3.3646,1.5,3.3646,3.4v1.9H1.9792V5.4z M15.8333,25.7 v2.9c0,1.4-0.9895,3.4-3.3645,3.4c-1.0886,0-1.8803-0.9-1.8803-1.9V8.3V5.4c0-1.3-0.4947-2.4-1.1875-3.4h17.5157 c2.5729,0,4.75,2.2,4.75,4.8v17.9H16.8229C16.2292,24.7,15.8333,25.2,15.8333,25.7z M36.0208,28.6c0,1.4-0.9896,3.4-3.3646,3.4 H16.625c0.7917-1,1.1875-2.2,1.1875-3.4v-1.9h18.2083V28.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#090927",
    d: "M15.3387,9.3h10.0938c0.5937,0,0.9895-0.4,0.9895-1s-0.3958-1-0.9895-1H15.3387 c-0.5937,0-0.9896,0.4-0.9896,1S14.8439,9.3,15.3387,9.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#090927",
    d: "M15.3387,15.1001h8.6094c0.5937,0,0.9896-0.4,0.9896-1c0-0.6-0.3959-1-0.9896-1h-8.6094 c-0.5937,0-0.9896,0.4-0.9896,1C14.3491,14.7001,14.8439,15.1001,15.3387,15.1001z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#090927",
    d: "M27.9064,19.8999c0-0.6-0.3958-1-0.9896-1H15.3387c-0.5937,0-0.9896,0.4-0.9896,1s0.3959,1,0.9896,1h11.4792 C27.4116,20.8999,27.9064,20.4999,27.9064,19.8999z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWill2);
export default __webpack_public_path__ + "static/media/will2.98fd4b8d8c8987a552703690f42bd272.svg";
export { ForwardRef as ReactComponent };